import { useMachineEtatStore, type MachineEtatStoreResult } from './useMachineEtatStore'
import type { RunComponentOptions } from './types'

export type IMachineEtatDisplay = ReturnType<typeof useMachineEtatDisplay>

export function useMachineEtatDisplay() {
  const store = useMachineEtatStore()

  const runComponent = (options: RunComponentOptions) => {
    return store.runTransaction(options) as Promise<MachineEtatStoreResult>
  }

  const hide = () => store.$reset()

  return { runComponent, hide }
}
